import clsx from 'clsx';

import styles from './Skeleton.module.scss';

interface SkeletonProps {
  height?: number;
  count?: number;
  /**
   * Радиус под то, что заглушка заменяет.
   *
   * `card` (по умолчанию) — карточный, как у `RADIUS.xl` настоящих
   * карточек. `compact` — для невысоких строк: карточный радиус у полосы
   * в 28–46px съедает половину высоты и превращает её в капсулу.
   */
  shape?: 'card' | 'compact';
}

/** Порог, ниже которого карточный радиус визуально съедает полосу. */
const COMPACT_HEIGHT = 64;

export function Skeleton({ height = 72, count = 1, shape }: SkeletonProps) {
  // Вызывающих сторон восемь, и почти все передают только высоту.
  // Поэтому форма выводится из неё, а `shape` нужен лишь там, где
  // догадка неверна.
  const resolved = shape ?? (height < COMPACT_HEIGHT ? 'compact' : 'card');

  return (
    <div className={styles.stack} aria-hidden>
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className={clsx(styles.bar, resolved === 'compact' && styles.compact)}
          style={{ height }}
        />
      ))}
    </div>
  );
}
